import React from 'react';


export default class DerivedState extends React.Component {
    constructor(props) {
      super(props);
       this.state = {
            check:this.props.checked,
            checked:this.props.checkedText
}
    }

     componentDidMount(){
    }

   static getDerivedStateFromProps(props,state){

   // console.log('chack :', props.checked);
        if(props.checked !== state.check){

            // console.log('derived this.props.checked :', props.checked);
            return{
                check:props.checked,
                checked:props.checkedText

            };

        
        }
        return null
    }


     render() { 
       return (
          <div>
              {this.state.checked}
         </div>
        );
       }
}